import { useMutation, useQueryCache } from "react-query";
import { useToasts } from "react-toast-notifications";
import { getInspectionQueryKey } from "./useInspection";
import { deleteInspectionById } from "../../api/inspections/deleteInspectionById";
import { InspectionsQueryKey } from "./useInspections";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

interface Params {
  id: string | number;
  onSuccess?: () => void;
}
export default function useInspectionDeleteMutation({ id, onSuccess = () => {} }: Params) {
  const queryCache = useQueryCache();
  const toasts = useToasts();

  const inspectionListQueryKey = InspectionsQueryKey();
  const inspectionQueryKey = getInspectionQueryKey(id);
  const networkHeaders = useNetworkHeaders();

  const [deleteInspection, deleteInspectionState] = useMutation(deleteInspectionById(networkHeaders, Number(id)), {
    onSuccess: () => {
      toasts.addToast("Inspection deleted successfully", { appearance: "success", autoDismiss: true });
      // We can safely remove the query without refetching because we're deleting the inspection
      queryCache.removeQueries(inspectionQueryKey);
      queryCache.removeQueries(inspectionListQueryKey);
      // TODO: Add a function or const for this query key. I think this is the query-key for the inspections list (elastic-search)
      // Tbh not sure if this really does anything right now, but it should in theory right?
      queryCache.invalidateQueries("inspections.list");
      onSuccess();
    },
    onError: () => {
      toasts.addToast("Failed to delete an inspection", { appearance: "error", autoDismiss: true });
    },
  });

  return {
    isLoading: deleteInspectionState.isLoading,
    deleteInspection: () => deleteInspection(),
  };
}
